import { getEnvironments } from 'store/useAtomOutsideComponent';
import { SECURE_CONFIG } from './secureConfig';

const {
  // Config
  NODE_ENV,
  REACT_APP_SECRET_SSO,
  REACT_APP_SECRET_SSO_ENV = '',
  // Firebase
  REACT_APP_FS_CONF_API_KEY,
  REACT_APP_FS_CONF_AUTH_DOMAIN,
  REACT_APP_FS_CONF_DATABASE_URL,
  REACT_APP_FS_CONF_PROJECT_ID,
  REACT_APP_FS_CONF_STORAGE_BUCKET,
  REACT_APP_FS_CONF_MESSAGING_SENDER_ID,
  REACT_APP_FS_CONF_APP_ID,

  REACT_APP_FS_SERVICES_CONF_API_KEY,
  REACT_APP_FS_SERVICES_CONF_AUTH_DOMAIN,
  REACT_APP_FS_SERVICES_CONF_DATABASE_URL,
  REACT_APP_FS_SERVICES_CONF_PROJECT_ID,
  REACT_APP_FS_SERVICES_CONF_STORAGE_BUCKET,
  REACT_APP_FS_SERVICES_CONF_MESSAGING_SENDER_ID,
  REACT_APP_FS_SERVICES_CONF_APP_ID,
  // ENCRYPT KEY
  REACT_APP_CONFIG_WORD_ENV,
  // API's REST
  REACT_APP_API_REST_URL,
  REACT_APP_API_REST_URL_ENV,
  REACT_APP_API_REST_URL_AUTH_SECURE,
  REACT_APP_API_REST_URL_AUTH_SECURE_ENV,
  REACT_APP_API_REST_URL_AUTH_PUBLIC,
  REACT_APP_API_REST_URL_AUTH_PUBLIC_ENV,
  REACT_APP_API_REST_EVALUATIONS_URL,
  REACT_APP_API_REST_EVALUATIONS_URL_ENV,
  REACT_APP_API_REST_URL_OBJECTIVES,
  REACT_APP_API_REST_URL_OBJECTIVES_ENV,
  REACT_APP_API_REST_URL_DA,
  REACT_APP_API_REST_URL_DA_ENV,
  REACT_APP_API_REST_URL_REPORTS,
  REACT_APP_API_REST_URL_REPORTS_ENV,
  REACT_APP_API_REST_URL_CERTIFICATES,
  REACT_APP_API_REST_URL_CERTIFICATES_ENV,
  REACT_APP_API_REST_STRATEGIES_HUB_URL,
  REACT_APP_API_REST_STRATEGIES_HUB_URL_ENV,
  // Hasura
  REACT_APP_API_BASE,
  REACT_APP_API_BASE_ENV = '',
  REACT_APP_API_WS_BASE,
  REACT_APP_API_WS_BASE_ENV = '',
  REACT_APP_API_ADMIN_SECRET,
  REACT_APP_API_ADMIN_SECRET_ENV = '',
  // Amplitude
  REACT_APP_AMPLITUDE_KEY,
  REACT_APP_AMPLITUDE_KEY_ENV = null,
  REACT_APP_FROALA_KEY,
  REACT_APP_FROALA_KEY_ENV = '',
  // Subdomain
  REACT_APP_SUBDOMAIN_SSO,
  REACT_APP_SUBDOMAIN_SSO_ENV = '',
  // Search Engine Service
  REACT_APP_SES_API_KEY,
  REACT_APP_SES_API_KEY_ENV,
  REACT_APP_HOST_AUTH,
  REACT_APP_HOST_AUTH_ENV = '',
  REACT_APP_SECRET_WORD,
  REACT_APP_SECRET_WORD_ENV = '',
  // Hubspot
  REACT_APP_LXP_URL,
  REACT_APP_LXP_URL_ENV = '',
  REACT_APP_SHOW_SUPPORT_CHAT,
  REACT_APP_SHOW_SUPPORT_CHAT_ENV = false,
  // Cloudinary
  REACT_APP_API_CLOUDINARY,
  REACT_APP_API_CLOUDINARY_ENV = '',
  // Cloudfunctions LMS
  REACT_APP_API_CLOUDFUNCTIONS,
  REACT_APP_API_CLOUDFUNCTIONS_ENV = '',
  // Notifications LXP Configs
  REACT_APP_NOTIFICATIONS_LXP_API_KEY,
  REACT_APP_NOTIFICATIONS_LXP_API_KEY_ENV = '',
  REACT_APP_NOTIFICATIONS_API_ENDPOINT,
  REACT_APP_NOTIFICATIONS_API_ENDPOINT_ENV = '',
  REACT_APP_SEND_NOTIFICATIONS,
  REACT_APP_SEND_NOTIFICATIONS_ENV = '',
  REACT_APP_COMMUNITY_URL = '',
  REACT_APP_COMMUNITY_URL_ENV = '',
  REACT_APP_MS_LXP_WRAPPER,
  REACT_APP_MS_LXP_WRAPPER_ENV = '',
  // LMS
  REACT_APP_LMS_URL = '',
  REACT_APP_LMS_URL_ENV = '',
  REACT_APP_BACK_LMS_URL,
  REACT_APP_BACK_LMS_URL_ENV = '',
  // Diagnoses Url
  REACT_APP_DIAGNOSES_URL,
  REACT_APP_DIAGNOSES_URL_ENV = '',
  REACT_APP_API_REST_URL_BOLSA,
  REACT_APP_API_REST_URL_BOLSA_ENV,
  // Survey IDs
  REACT_APP_CSAT_PROFILE_ID,
  REACT_APP_CSAT_PROFILE_ID_ENV = '',
  REACT_APP_CSAT_ADMIN_USERS_ID,
  REACT_APP_CSAT_ADMIN_USERS_ID_ENV = '',
  REACT_APP_CSAT_USER_DIAGNOSES_ID,
  REACT_APP_CSAT_USER_DIAGNOSES_ID_ENV = '',
  REACT_APP_API_BASE_V1,
  REACT_APP_API_BASE_V1_ENV = '',
  REACT_APP_API_ADMIN_SECRET_V1,
  REACT_APP_API_ADMIN_SECRET_V1_ENV = '',
  REACT_APP_API_REST_URL_PROXY,
  REACT_APP_API_REST_URL_PROXY_ENV,
  REACT_APP_API_REST_URL_WORK_ENVIRONMENT,
  REACT_APP_API_REST_URL_WORK_ENVIRONMENT_ENV = '',
  REACT_APP_API_REST_URL_COPILOT_ACTIVACION,
  REACT_APP_API_REST_URL_COPILOT_ACTIVACION_ENV = '',
  REACT_APP_API_REST_URL_COPILOT_APRENDIZAJE,
  REACT_APP_API_REST_URL_COPILOT_APRENDIZAJE_ENV = '',
  REACT_APP_IDENTITY_FS_API_KEY,
  REACT_APP_IDENTITY_FS_API_KEY_ENV = '',
  REACT_APP_IDENTITY_FS_AUTH_DOMAIN,
  REACT_APP_IDENTITY_FS_AUTH_DOMAIN_ENV = '',
  REACT_APP_IDENTITY_FS_DATABASE_URL,
  REACT_APP_IDENTITY_FS_DATABASE_URL_ENV = '',
  //app config
  REACT_APP_COPILOT_APRENDIZAJE_API_KEY,
  REACT_APP_COPILOT_APRENDIZAJE_API_KEY_ENV = '',
  // DXC IA
  REACT_APP_API_REST_URL_IA_COMPETENCIES,
  REACT_APP_API_REST_URL_IA_COMPETENCIES_ENV = '',
  // Product Fruits
  REACT_APP_PRODUCT_FRUITS_WS_CODE,
  REACT_APP_PRODUCT_FRUITS_WS_CODE_ENV = '',

  // Webhook - n8n
  REACT_APP_API_REST_URL_WEBHOOK,
  REACT_APP_API_REST_URL_WEBHOOK_ENV = '',

  // Recruitment 
  REACT_APP_RECRUITMENT_URL = '',
  REACT_APP_RECRUITMENT_API_URL = '',
  REACT_APP_RECRUITMENT_API_KEY = '',

  REACT_APP_RESPONSE_ENCRYPTION_KEY = '',
  REACT_APP_COURSE_EXPRESS_API_URL = '',
  REACT_APP_POSTHOG_HOST = '',
  REACT_APP_POSTHOG_HOST_ENV = '',
  REACT_APP_POSTHOG_API_KEY = null,
  REACT_APP_POSTHOG_API_KEY_ENV = null,
} = process.env;

const STORE_KEYS = [
  'REACT_APP_SECRET_SSO',
  'REACT_APP_CONFIG_WORD',
  'REACT_APP_API_REST_URL',
  'REACT_APP_API_REST_URL_AUTH_SECURE',
  'REACT_APP_API_REST_URL_AUTH_PUBLIC',
  'REACT_APP_API_REST_EVALUATIONS_URL',
  'REACT_APP_API_REST_URL_OBJECTIVES',
  'REACT_APP_API_REST_URL_DA',
  'REACT_APP_API_REST_URL_REPORTS',
  'REACT_APP_API_REST_URL_CERTIFICATES',
  'REACT_APP_API_REST_STRATEGIES_HUB_URL',
  'REACT_APP_API_BASE',
  'REACT_APP_API_WS_BASE',
  'REACT_APP_AMPLITUDE_KEY',
  'REACT_APP_FROALA_KEY',
  'REACT_APP_SUBDOMAIN_SSO',
  'REACT_APP_SES_API_KEY',
  'REACT_APP_HOST_AUTH',
  'REACT_APP_SECRET_WORD',
  'REACT_APP_LXP_URL',
  'REACT_APP_SHOW_SUPPORT_CHAT',
  'REACT_APP_API_CLOUDINARY',
  'REACT_APP_API_CLOUDFUNCTIONS',
  'REACT_APP_NOTIFICATIONS_LXP_API_KEY',
  'REACT_APP_NOTIFICATIONS_API_ENDPOINT',
  'REACT_APP_SEND_NOTIFICATIONS',
  'REACT_APP_MS_LXP_WRAPPER',
  'REACT_APP_BACK_LMS_URL',
  'REACT_APP_DIAGNOSES_URL',
  'REACT_APP_API_REST_URL_BOLSA',
  'REACT_APP_CSAT_PROFILE_ID',
  'REACT_APP_CSAT_ADMIN_USERS_ID',
  'REACT_APP_CSAT_USER_DIAGNOSES_ID',
  'REACT_APP_API_BASE_V1',
  'REACT_APP_API_ADMIN_SECRET_V1',
  'REACT_APP_API_REST_URL_PROXY',
  'REACT_APP_API_REST_URL_WORK_ENVIRONMENT',
  'REACT_APP_API_REST_URL_COPILOT_ACTIVACION',
  'REACT_APP_API_REST_URL_COPILOT_APRENDIZAJE',
  'REACT_APP_IDENTITY_FS_API_KEY',
  'REACT_APP_IDENTITY_FS_AUTH_DOMAIN',
  'REACT_APP_IDENTITY_FS_DATABASE_URL',
  'REACT_APP_COPILOT_APRENDIZAJE_API_KEY',
  'REACT_APP_API_REST_URL_IA_COMPETENCIES',
  'REACT_APP_PRODUCT_FRUITS_WS_CODE',
  'REACT_APP_API_REST_URL_WEBHOOK',
  'REACT_APP_POSTHOG_HOST',
  'REACT_APP_POSTHOG_API_KEY',
];

/**
 * Lee las variables del store de secrets. Antes de que carguen los secrets el
 * store está vacío; por eso `refreshEnvVars()` reasigna todas las exportaciones
 * derivadas del store en cuanto los secrets están disponibles (ver environment.ts).
 */
const readStoreEnv = (): Record<string, any> =>
  getEnvironments({ keys: STORE_KEYS });

let storeEnv: Record<string, any> = readStoreEnv();

// ---------------------------------------------------------------------------
// Helper de prioridad: controla si gana .env o secrets.
// Se activa vía REACT_APP_ENV_PRIORITY=local en los scripts *-local y *:urls.
// Sin la variable: secrets tienen prioridad (comportamiento por defecto).
// ---------------------------------------------------------------------------
const __ENV_PRIORITY = process.env.REACT_APP_ENV_PRIORITY === 'local';

/**
 * Helper de compatibilidad: prueba nombre sin _ENV primero, cae a _ENV legacy.
 */
const env = (standard: string | boolean | null | undefined, legacy: string | boolean | null | undefined): string | undefined =>
  (standard || legacy || undefined) as string | undefined;

/**
 * Resuelve una variable con prioridad controlada por REACT_APP_ENV_PRIORITY.
 * Sin flag:          store (secrets) primero, .env como fallback
 * Con local:         .env primero, store como fallback
 *
 * Nota: valores falsy (false, 0, "", null, undefined) se tratan como "no definido"
 * y causan caída al otro origen. Si en el futuro se necesita overridear con un
 * string vacío, este helper requeriría un tercer estado (null vs "").
 */
const p = (
  envVal: string | boolean | undefined | null,
  storeVal: string | undefined | null,
): string => {
  const env = typeof envVal === 'boolean' ? '' : (envVal || '');
  const store = storeVal || '';
  return __ENV_PRIORITY ? env || store : store || env;
};

// ---------------------------------------------------------------------------
// Valores que NO dependen del store de secrets (build-time o SECURE_CONFIG).
// Se resuelven una sola vez; nunca cambian en runtime.
// ---------------------------------------------------------------------------
export const isDev = NODE_ENV !== 'production';
export const REACT_NODE_ENV = NODE_ENV;

export const FIREBASE_CONFIG = {
  apiKey: REACT_APP_FS_CONF_API_KEY,
  authDomain: REACT_APP_FS_CONF_AUTH_DOMAIN,
  databaseURL: REACT_APP_FS_CONF_DATABASE_URL,
  projectId: REACT_APP_FS_CONF_PROJECT_ID,
  storageBucket: REACT_APP_FS_CONF_STORAGE_BUCKET,
  messagingSenderId: REACT_APP_FS_CONF_MESSAGING_SENDER_ID,
  appId: REACT_APP_FS_CONF_APP_ID,
};

export const SERVICES_FIREBASE_CONFIG = {
  apiKey: REACT_APP_FS_SERVICES_CONF_API_KEY,
  authDomain: REACT_APP_FS_SERVICES_CONF_AUTH_DOMAIN,
  databaseURL: REACT_APP_FS_SERVICES_CONF_DATABASE_URL,
  projectId: REACT_APP_FS_SERVICES_CONF_PROJECT_ID,
  storageBucket: REACT_APP_FS_SERVICES_CONF_STORAGE_BUCKET,
  messagingSenderId: REACT_APP_FS_SERVICES_CONF_MESSAGING_SENDER_ID,
  appId: REACT_APP_FS_SERVICES_CONF_APP_ID,
};

// Configuraciones seguras con fallback encriptado (síncronas, siempre disponibles).
// Con REACT_APP_ENV_PRIORITY=local, el .env puede overridear estas URLs.
export const CONFIG_WORD = SECURE_CONFIG.CONFIG_WORD;
export const API_REST_URL_AUTH_SECURE =
  p(env(REACT_APP_API_REST_URL_AUTH_SECURE, REACT_APP_API_REST_URL_AUTH_SECURE_ENV), SECURE_CONFIG.API_REST_URL_AUTH_SECURE);
export const API_REST_URL_AUTH_PUBLIC =
  p(env(REACT_APP_API_REST_URL_AUTH_PUBLIC, REACT_APP_API_REST_URL_AUTH_PUBLIC_ENV), SECURE_CONFIG.API_REST_URL_AUTH_PUBLIC);
export const API_REST_URL =
  p(env(REACT_APP_API_REST_URL, REACT_APP_API_REST_URL_ENV), SECURE_CONFIG.API_REST_URL);
export const API_REST_URL_PROXY =
  p(REACT_APP_API_REST_URL_PROXY, SECURE_CONFIG.API_REST_URL_PROXY);
export const COMMUNITY_URL =
  p(env(REACT_APP_COMMUNITY_URL, REACT_APP_COMMUNITY_URL_ENV), SECURE_CONFIG.REACT_APP_COMMUNITY_URL);
export const LMS_URL =
  p(env(REACT_APP_LMS_URL, REACT_APP_LMS_URL_ENV), SECURE_CONFIG.REACT_APP_LMS_URL);

export const RECRUITMENT_URL = REACT_APP_RECRUITMENT_URL || '';
export const RECRUITMENT_API_URL = REACT_APP_RECRUITMENT_API_URL || '';
export const RECRUITMENT_API_KEY = REACT_APP_RECRUITMENT_API_KEY || '';
export const COURSE_EXPRESS_API_URL = REACT_APP_COURSE_EXPRESS_API_URL || '';
export const RESPONSE_ENCRYPTION_KEY = REACT_APP_RESPONSE_ENCRYPTION_KEY || '';

// ---------------------------------------------------------------------------
// Valores que SÍ dependen del store de secrets. Se exportan como live bindings
// (`let`) y se recalculan con `refreshEnvVars()` en cuanto cargan los secrets,
// para que nunca queden congelados vacíos (causa de URLs `.../undefined/...`).
// ---------------------------------------------------------------------------
export let SECRET_SSO = p(env(REACT_APP_SECRET_SSO, REACT_APP_SECRET_SSO_ENV), storeEnv.REACT_APP_SECRET_SSO);
export let SECRET_WORD = p(env(REACT_APP_SECRET_WORD, REACT_APP_SECRET_WORD_ENV), storeEnv.REACT_APP_SECRET_WORD);
export let HOST = p(env(REACT_APP_HOST_AUTH, REACT_APP_HOST_AUTH_ENV), storeEnv.REACT_APP_HOST_AUTH);

export let FIREBASE_CONFIG_IDENTITY = {
  apiKey: storeEnv.REACT_APP_IDENTITY_FS_API_KEY,
  authDomain: storeEnv.REACT_APP_IDENTITY_FS_AUTH_DOMAIN,
  databaseURL: storeEnv.REACT_APP_IDENTITY_FS_DATABASE_URL,
};

export let API_BASE = p(env(REACT_APP_API_BASE, REACT_APP_API_BASE_ENV), storeEnv.REACT_APP_API_BASE);
export let API_WS_BASE = p(env(REACT_APP_API_WS_BASE, REACT_APP_API_WS_BASE_ENV), storeEnv.REACT_APP_API_WS_BASE);
export let ADMIN_SECRET = p(env(REACT_APP_API_ADMIN_SECRET_V1, REACT_APP_API_ADMIN_SECRET_V1_ENV), storeEnv.REACT_APP_API_ADMIN_SECRET_V1);

export let API_REST_URL_REPORTS =
  p(env(REACT_APP_API_REST_URL_REPORTS, REACT_APP_API_REST_URL_REPORTS_ENV), storeEnv.REACT_APP_API_REST_URL_REPORTS) || '';
export let API_REST_URL_OBJECTIVES =
  p(env(REACT_APP_API_REST_URL_OBJECTIVES, REACT_APP_API_REST_URL_OBJECTIVES_ENV), storeEnv.REACT_APP_API_REST_URL_OBJECTIVES) || '';
export let API_REST_URL_DA =
  p(env(REACT_APP_API_REST_URL_DA, REACT_APP_API_REST_URL_DA_ENV), storeEnv.REACT_APP_API_REST_URL_DA) || '';
export let API_REST_URL_BOLSA =
  p(env(REACT_APP_API_REST_URL_BOLSA, REACT_APP_API_REST_URL_BOLSA_ENV), storeEnv.REACT_APP_API_REST_URL_BOLSA) || '';
export let API_REST_MS_LXP_WRAPPER =
  p(env(REACT_APP_MS_LXP_WRAPPER, REACT_APP_MS_LXP_WRAPPER_ENV), storeEnv.REACT_APP_MS_LXP_WRAPPER) || '';
export let API_REST_URL_CERTIFICATES =
  p(env(REACT_APP_API_REST_URL_CERTIFICATES, REACT_APP_API_REST_URL_CERTIFICATES_ENV), storeEnv.REACT_APP_API_REST_URL_CERTIFICATES) || '';

export let API_REST_URL_COPILOT_ACTIVACION =
  p(env(REACT_APP_API_REST_URL_COPILOT_ACTIVACION, REACT_APP_API_REST_URL_COPILOT_ACTIVACION_ENV), storeEnv.REACT_APP_API_REST_URL_COPILOT_ACTIVACION) || '';
export let API_REST_URL_COPILOT_APRENDIZAJE =
  p(env(REACT_APP_API_REST_URL_COPILOT_APRENDIZAJE, REACT_APP_API_REST_URL_COPILOT_APRENDIZAJE_ENV), storeEnv.REACT_APP_API_REST_URL_COPILOT_APRENDIZAJE) || '';
export let COPILOT_APRENDIZAJE_API_KEY =
  p(env(REACT_APP_COPILOT_APRENDIZAJE_API_KEY, REACT_APP_COPILOT_APRENDIZAJE_API_KEY_ENV), storeEnv.REACT_APP_COPILOT_APRENDIZAJE_API_KEY) || '';
export let API_REST_EVALUATIONS_URL =
  p(env(REACT_APP_API_REST_EVALUATIONS_URL, REACT_APP_API_REST_EVALUATIONS_URL_ENV), storeEnv.REACT_APP_API_REST_EVALUATIONS_URL) || '';

export let API_REST_STRATEGIES_HUB =
  p(env(REACT_APP_API_REST_STRATEGIES_HUB_URL, REACT_APP_API_REST_STRATEGIES_HUB_URL_ENV), storeEnv.REACT_APP_API_REST_STRATEGIES_HUB_URL) || '';

export let AMPLITUDE_KEY = isDev
  ? null
  : p(env(REACT_APP_AMPLITUDE_KEY, REACT_APP_AMPLITUDE_KEY_ENV), storeEnv.REACT_APP_AMPLITUDE_KEY);

export let POSTHOG_HOST =
  p(env(REACT_APP_POSTHOG_HOST, REACT_APP_POSTHOG_HOST_ENV), storeEnv.REACT_APP_POSTHOG_HOST) ||
  'https://us.i.posthog.com';
export let POSTHOG_KEY =
  p(env(REACT_APP_POSTHOG_API_KEY, REACT_APP_POSTHOG_API_KEY_ENV), storeEnv.REACT_APP_POSTHOG_API_KEY) ||
  null;

export let SUBDOMAIN_SSO = p(env(REACT_APP_SUBDOMAIN_SSO, REACT_APP_SUBDOMAIN_SSO_ENV), storeEnv.REACT_APP_SUBDOMAIN_SSO);

export let API_SEARCH = p(env(REACT_APP_SES_API_KEY, REACT_APP_SES_API_KEY_ENV), storeEnv.REACT_APP_SES_API_KEY) || '';

export let LXP_BACK_URL = p(env(REACT_APP_LXP_URL, REACT_APP_LXP_URL_ENV), storeEnv.REACT_APP_LXP_URL) || '';
export let SHOW_SUPPORT_CHAT = p(env(REACT_APP_SHOW_SUPPORT_CHAT, REACT_APP_SHOW_SUPPORT_CHAT_ENV), storeEnv.REACT_APP_SHOW_SUPPORT_CHAT);

export let API_CLOUDINARY = p(env(REACT_APP_API_CLOUDINARY, REACT_APP_API_CLOUDINARY_ENV), storeEnv.REACT_APP_API_CLOUDINARY);

export let API_CLOUD_FUNCTIONS_LMS = p(env(REACT_APP_API_CLOUDFUNCTIONS, REACT_APP_API_CLOUDFUNCTIONS_ENV), storeEnv.REACT_APP_API_CLOUDFUNCTIONS);

export let NOTIFICATIONS_API_KEY =
  p(env(REACT_APP_NOTIFICATIONS_LXP_API_KEY, REACT_APP_NOTIFICATIONS_LXP_API_KEY_ENV), storeEnv.REACT_APP_NOTIFICATIONS_LXP_API_KEY) || '';
export let NOTIFICATIONS_ENDPOINT =
  p(env(REACT_APP_NOTIFICATIONS_API_ENDPOINT, REACT_APP_NOTIFICATIONS_API_ENDPOINT_ENV), storeEnv.REACT_APP_NOTIFICATIONS_API_ENDPOINT) || '';
export let SEND_NOTIFICATIONS =
  p(env(REACT_APP_SEND_NOTIFICATIONS, REACT_APP_SEND_NOTIFICATIONS_ENV), storeEnv.REACT_APP_SEND_NOTIFICATIONS) || '';

export let DIAGNOSES_URL = p(env(REACT_APP_DIAGNOSES_URL, REACT_APP_DIAGNOSES_URL_ENV), storeEnv.REACT_APP_DIAGNOSES_URL) || '';

export let LMS_BACK_URL = p(env(REACT_APP_BACK_LMS_URL, REACT_APP_BACK_LMS_URL_ENV), storeEnv.REACT_APP_BACK_LMS_URL) || '';

export let API_BASE_V1 = p(env(REACT_APP_API_BASE_V1, REACT_APP_API_BASE_V1_ENV), storeEnv.REACT_APP_API_BASE);
export let API_ADMIN_SECRET_V1 = p(env(REACT_APP_API_ADMIN_SECRET_V1, REACT_APP_API_ADMIN_SECRET_V1_ENV), storeEnv.REACT_APP_API_ADMIN_SECRET_V1);

export let CSAT_PROFILE_ID = p(env(REACT_APP_CSAT_PROFILE_ID, REACT_APP_CSAT_PROFILE_ID_ENV), storeEnv.REACT_APP_CSAT_PROFILE_ID);
export let CSAT_ADMIN_USERS_ID = p(env(REACT_APP_CSAT_ADMIN_USERS_ID, REACT_APP_CSAT_ADMIN_USERS_ID_ENV), storeEnv.REACT_APP_CSAT_ADMIN_USERS_ID);
export let CSAT_USER_DIAGNOSES_ID = p(env(REACT_APP_CSAT_USER_DIAGNOSES_ID, REACT_APP_CSAT_USER_DIAGNOSES_ID_ENV), storeEnv.REACT_APP_CSAT_USER_DIAGNOSES_ID);

export let WORK_ENVIRONMENT_URL =
  p(env(REACT_APP_API_REST_URL_WORK_ENVIRONMENT, REACT_APP_API_REST_URL_WORK_ENVIRONMENT_ENV), storeEnv.REACT_APP_API_REST_URL_WORK_ENVIRONMENT) || '';

export let DXC_IA_COMPETENCIES_URL = p(env(REACT_APP_API_REST_URL_IA_COMPETENCIES, REACT_APP_API_REST_URL_IA_COMPETENCIES_ENV), storeEnv.REACT_APP_API_REST_URL_IA_COMPETENCIES);

export let PRODUCT_FRUITS_WS_CODE = storeEnv.REACT_APP_PRODUCT_FRUITS_WS_CODE;

export let API_REST_URL_WEBHOOK = storeEnv.REACT_APP_API_REST_URL_WEBHOOK || '';

/**
 * Recalcula todas las exportaciones que dependen del store de secrets.
 * Se invoca justo después de cargar los secrets (environment.ts), de modo que
 * cualquier módulo del bundle que se importe después lea valores correctos.
 */
export const refreshEnvVars = (): void => {
  storeEnv = readStoreEnv();

  SECRET_SSO = p(env(REACT_APP_SECRET_SSO, REACT_APP_SECRET_SSO_ENV), storeEnv.REACT_APP_SECRET_SSO);
  SECRET_WORD = p(env(REACT_APP_SECRET_WORD, REACT_APP_SECRET_WORD_ENV), storeEnv.REACT_APP_SECRET_WORD);
  HOST = p(env(REACT_APP_HOST_AUTH, REACT_APP_HOST_AUTH_ENV), storeEnv.REACT_APP_HOST_AUTH);

  FIREBASE_CONFIG_IDENTITY = {
    apiKey: storeEnv.REACT_APP_IDENTITY_FS_API_KEY,
    authDomain: storeEnv.REACT_APP_IDENTITY_FS_AUTH_DOMAIN,
    databaseURL: storeEnv.REACT_APP_IDENTITY_FS_DATABASE_URL,
  };

  API_BASE = p(env(REACT_APP_API_BASE, REACT_APP_API_BASE_ENV), storeEnv.REACT_APP_API_BASE);
  API_WS_BASE = p(env(REACT_APP_API_WS_BASE, REACT_APP_API_WS_BASE_ENV), storeEnv.REACT_APP_API_WS_BASE);
  ADMIN_SECRET = p(env(REACT_APP_API_ADMIN_SECRET_V1, REACT_APP_API_ADMIN_SECRET_V1_ENV), storeEnv.REACT_APP_API_ADMIN_SECRET_V1);

  API_REST_URL_REPORTS =
    p(env(REACT_APP_API_REST_URL_REPORTS, REACT_APP_API_REST_URL_REPORTS_ENV), storeEnv.REACT_APP_API_REST_URL_REPORTS) || '';
  API_REST_URL_OBJECTIVES =
    p(env(REACT_APP_API_REST_URL_OBJECTIVES, REACT_APP_API_REST_URL_OBJECTIVES_ENV), storeEnv.REACT_APP_API_REST_URL_OBJECTIVES) || '';
  API_REST_URL_DA =
    p(env(REACT_APP_API_REST_URL_DA, REACT_APP_API_REST_URL_DA_ENV), storeEnv.REACT_APP_API_REST_URL_DA) || '';
  API_REST_URL_BOLSA =
    p(env(REACT_APP_API_REST_URL_BOLSA, REACT_APP_API_REST_URL_BOLSA_ENV), storeEnv.REACT_APP_API_REST_URL_BOLSA) || '';
  API_REST_MS_LXP_WRAPPER =
    p(env(REACT_APP_MS_LXP_WRAPPER, REACT_APP_MS_LXP_WRAPPER_ENV), storeEnv.REACT_APP_MS_LXP_WRAPPER) || '';
  API_REST_URL_CERTIFICATES =
    p(env(REACT_APP_API_REST_URL_CERTIFICATES, REACT_APP_API_REST_URL_CERTIFICATES_ENV), storeEnv.REACT_APP_API_REST_URL_CERTIFICATES) || '';

  API_REST_URL_COPILOT_ACTIVACION =
    p(env(REACT_APP_API_REST_URL_COPILOT_ACTIVACION, REACT_APP_API_REST_URL_COPILOT_ACTIVACION_ENV), storeEnv.REACT_APP_API_REST_URL_COPILOT_ACTIVACION) || '';
  API_REST_URL_COPILOT_APRENDIZAJE =
    p(env(REACT_APP_API_REST_URL_COPILOT_APRENDIZAJE, REACT_APP_API_REST_URL_COPILOT_APRENDIZAJE_ENV), storeEnv.REACT_APP_API_REST_URL_COPILOT_APRENDIZAJE) || '';
  COPILOT_APRENDIZAJE_API_KEY =
    p(env(REACT_APP_COPILOT_APRENDIZAJE_API_KEY, REACT_APP_COPILOT_APRENDIZAJE_API_KEY_ENV), storeEnv.REACT_APP_COPILOT_APRENDIZAJE_API_KEY) || '';
  API_REST_EVALUATIONS_URL =
    p(env(REACT_APP_API_REST_EVALUATIONS_URL, REACT_APP_API_REST_EVALUATIONS_URL_ENV), storeEnv.REACT_APP_API_REST_EVALUATIONS_URL) || '';

  API_REST_STRATEGIES_HUB =
    p(env(REACT_APP_API_REST_STRATEGIES_HUB_URL, REACT_APP_API_REST_STRATEGIES_HUB_URL_ENV), storeEnv.REACT_APP_API_REST_STRATEGIES_HUB_URL) || '';

  AMPLITUDE_KEY = isDev
    ? null
    : p(env(REACT_APP_AMPLITUDE_KEY, REACT_APP_AMPLITUDE_KEY_ENV), storeEnv.REACT_APP_AMPLITUDE_KEY);

  POSTHOG_HOST =
    p(env(REACT_APP_POSTHOG_HOST, REACT_APP_POSTHOG_HOST_ENV), storeEnv.REACT_APP_POSTHOG_HOST) ||
    'https://us.i.posthog.com';
  POSTHOG_KEY =
    p(env(REACT_APP_POSTHOG_API_KEY, REACT_APP_POSTHOG_API_KEY_ENV), storeEnv.REACT_APP_POSTHOG_API_KEY) ||
    null;

  SUBDOMAIN_SSO = p(env(REACT_APP_SUBDOMAIN_SSO, REACT_APP_SUBDOMAIN_SSO_ENV), storeEnv.REACT_APP_SUBDOMAIN_SSO);

  API_SEARCH = p(env(REACT_APP_SES_API_KEY, REACT_APP_SES_API_KEY_ENV), storeEnv.REACT_APP_SES_API_KEY) || '';

  LXP_BACK_URL = p(env(REACT_APP_LXP_URL, REACT_APP_LXP_URL_ENV), storeEnv.REACT_APP_LXP_URL) || '';
  SHOW_SUPPORT_CHAT = p(env(REACT_APP_SHOW_SUPPORT_CHAT, REACT_APP_SHOW_SUPPORT_CHAT_ENV), storeEnv.REACT_APP_SHOW_SUPPORT_CHAT);

  API_CLOUDINARY = p(env(REACT_APP_API_CLOUDINARY, REACT_APP_API_CLOUDINARY_ENV), storeEnv.REACT_APP_API_CLOUDINARY);

  API_CLOUD_FUNCTIONS_LMS = p(env(REACT_APP_API_CLOUDFUNCTIONS, REACT_APP_API_CLOUDFUNCTIONS_ENV), storeEnv.REACT_APP_API_CLOUDFUNCTIONS);

  NOTIFICATIONS_API_KEY =
    p(env(REACT_APP_NOTIFICATIONS_LXP_API_KEY, REACT_APP_NOTIFICATIONS_LXP_API_KEY_ENV), storeEnv.REACT_APP_NOTIFICATIONS_LXP_API_KEY) || '';
  NOTIFICATIONS_ENDPOINT =
    p(env(REACT_APP_NOTIFICATIONS_API_ENDPOINT, REACT_APP_NOTIFICATIONS_API_ENDPOINT_ENV), storeEnv.REACT_APP_NOTIFICATIONS_API_ENDPOINT) || '';
  SEND_NOTIFICATIONS =
    p(env(REACT_APP_SEND_NOTIFICATIONS, REACT_APP_SEND_NOTIFICATIONS_ENV), storeEnv.REACT_APP_SEND_NOTIFICATIONS) || '';

  DIAGNOSES_URL = p(env(REACT_APP_DIAGNOSES_URL, REACT_APP_DIAGNOSES_URL_ENV), storeEnv.REACT_APP_DIAGNOSES_URL) || '';

  LMS_BACK_URL = p(env(REACT_APP_BACK_LMS_URL, REACT_APP_BACK_LMS_URL_ENV), storeEnv.REACT_APP_BACK_LMS_URL) || '';

  API_BASE_V1 = p(env(REACT_APP_API_BASE_V1, REACT_APP_API_BASE_V1_ENV), storeEnv.REACT_APP_API_BASE);
  API_ADMIN_SECRET_V1 = p(env(REACT_APP_API_ADMIN_SECRET_V1, REACT_APP_API_ADMIN_SECRET_V1_ENV), storeEnv.REACT_APP_API_ADMIN_SECRET_V1);

  CSAT_PROFILE_ID = p(env(REACT_APP_CSAT_PROFILE_ID, REACT_APP_CSAT_PROFILE_ID_ENV), storeEnv.REACT_APP_CSAT_PROFILE_ID);
  CSAT_ADMIN_USERS_ID = p(env(REACT_APP_CSAT_ADMIN_USERS_ID, REACT_APP_CSAT_ADMIN_USERS_ID_ENV), storeEnv.REACT_APP_CSAT_ADMIN_USERS_ID);
  CSAT_USER_DIAGNOSES_ID = p(env(REACT_APP_CSAT_USER_DIAGNOSES_ID, REACT_APP_CSAT_USER_DIAGNOSES_ID_ENV), storeEnv.REACT_APP_CSAT_USER_DIAGNOSES_ID);

  WORK_ENVIRONMENT_URL =
    p(env(REACT_APP_API_REST_URL_WORK_ENVIRONMENT, REACT_APP_API_REST_URL_WORK_ENVIRONMENT_ENV), storeEnv.REACT_APP_API_REST_URL_WORK_ENVIRONMENT) || '';

  DXC_IA_COMPETENCIES_URL = p(env(REACT_APP_API_REST_URL_IA_COMPETENCIES, REACT_APP_API_REST_URL_IA_COMPETENCIES_ENV), storeEnv.REACT_APP_API_REST_URL_IA_COMPETENCIES);

  PRODUCT_FRUITS_WS_CODE = storeEnv.REACT_APP_PRODUCT_FRUITS_WS_CODE;

  API_REST_URL_WEBHOOK = storeEnv.REACT_APP_API_REST_URL_WEBHOOK || '';
};
